import { TableData } from '@uikit/Tables/types';
import { createSlice } from '@reduxjs/toolkit';
import { placesApi } from '@store/rtk/places';
import { developData } from './utils';
import { TABLE_COLUMNS } from '@uikit/Tables/columns';

type ServicesSliceType = {
  servicesData: TableData;
};

const { servicesColumns } = TABLE_COLUMNS;

const initialState: ServicesSliceType = {
  servicesData: {
    columns: servicesColumns,
    rows: [],
    size: 5,
  },
};

export const placesServicesSlice = createSlice({
  name: 'services',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      placesApi.endpoints.getPlaceServices.matchFulfilled,
      (state, { payload }) => {
        if (payload.content && Array.isArray(payload.content)) {
          state.servicesData = {
            ...state.servicesData,
            rows: [...developData(payload.content)],
            ...payload,
            requestTablePageChange: placesApi.endpoints.getPlaceServices,
            filter: payload.filter || {},
          };
        } else {
          state.servicesData.rows = [...developData(payload)];
        }
      }
    );
  },
});

export const selectPlacesServices = (state) => state.services;
export const placesServicesReducer = placesServicesSlice.reducer;
